import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Toastr } from "../../revvComponents";
// Utils import
import { getSelectedText } from "../../utils/draftUtils";

import { isNewNoteOpen } from "../Notes/utils";

import { NOTES_STRINGS } from "../../stringConstants/index";

class AddNote extends Component {
  _onClick = event => {
    if (this.props.isNotesopen) {
      Toastr.showToastr({
        type: "warning",
        message: NOTES_STRINGS.OPEN_NOTES_ERROR,
        timeout: 6000,
      });
      return;
    }
    event.preventDefault();
    const {
      addNote,
      component,
      editorState,
      highlightSelection,
      removeHighlightSelection,
    } = this.props;
    const selectedText = getSelectedText(editorState);
    highlightSelection();
    addNote(selectedText, editorState, component, removeHighlightSelection);
  };

  onWindowClick = () => {
    this.props.onOverrideContent(undefined);
  };
  // Call `onOverrideContent` again with `undefined`
  // so the toolbar can show its regular content again.

  _getButton = () => (
    <div
      className="draft-edit-items"
      id="toolbar-add-note-button"
      key="toolbar-add-note-button">
      <div className="draftJsToolbar__buttonWrapper__1Dmqh">
        <button
          type="button"
          className="add-note-button"
          onMouseDown={this._onClick}
          data-test="addnote-btn">
          <i>
            <FontAwesomeIcon icon={["fad", "comments-alt"]} />
          </i>
          Add Note
        </button>
      </div>
    </div>
  );

  render() {
    return this._getButton();
  }
}
const mapStateToProps = state => {
  const { documentNotes } = state.NotesStore;
  const isNotesopen = isNewNoteOpen(documentNotes);
  return { isNotesopen };
};

export default connect(mapStateToProps, null)(AddNote);
